<template>
  <div class="brand">
    <img
      class="image-item"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/489ce07524faceffa24f61e2d67964ad.png"
      alt=""
    />
    <img
      class="image-item"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d1881ee2261e64b618fc0757fdca338e.png"
      alt=""
    />
    <div class="image-container">
      <img
        class="image-item"
        src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-04/9ead30d330816ed128d006cba6bb7dc7_wh=1500_3576.webp"
        alt=""
      />
      <div class="btn btn-1" @click="bindToTonicHome"></div>
    </div>
    <img
      class="image-item"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/4790642b7b4a6199d3b1d285a056695d.png"
      alt=""
    />
    <div class="image-container">
      <img
        class="image-item"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a1bfe495f464dd1d2332feb914e5ec55.png"
        alt=""
      />
      <div class="btn btn-2" @click="bindToMiniprogram"></div>
    </div>
    <div class="image-container">
      <img
        class="image-item"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/dfcf07aa6a36299080600d87f9a64bd6.png"
        alt=""
      />
      <div class="btn btn-3" @click="bindToVip"></div>
      <div class="btn btn-4" @click="bindToRecommendGoods"></div>
    </div>
    <div class="image-container">
      <img
        class="image-item"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/491f1234c972594153124db5d3c47838.png"
        alt=""
      />
      <div class="btn btn-5" @click="bindToNewQuestion"></div>
      <div class="btn-list">
        <div
          class="btn-item"
          v-for="(item, index) in 6"
          :key="index"
          @click="bindToTools(index)"
        ></div>
      </div>
    </div>
    <img
      class="image-item"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9f3c13b342c62e046cb5ba5039e99063.png"
      alt=""
    />
    <img
      class="image-item"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/1e2aa38315b70f3e94987b7d890d228e.png"
      alt=""
    />
    <div class="image-container">
      <img
        class="image-item"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b90e23f377a7c0a922fec66b3b4c28a4.png"
        alt=""
      />
      <div class="case-scroll" @scroll="bindScrollCase">
        <div class="case-list">
          <img
            class="case-item"
            :src="item.image"
            alt=""
            v-for="(item, index) in caseList"
            :key="index"
            @click="bindToCaseDetail(item.id)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HTTP from '@/request/index'
import { throttle } from '@/common/common.js'
export default {
  components: {},
  data() {
    return {
      caseList: [
        {
          id: 1386,
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a7ff35abfeb9cb008a2febecf84a4dff.png'
        },
        {
          id: 1353,
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f9558c9035ad1cc8219eb36d49451784.png'
        },
        {
          id: 345,
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/edeaca1b3031cc3410517eed55649f35.png'
        },
        {
          id: 1255,
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/91eb3da27bda5afa24d869cc15402d6e.png'
        }
      ]
    }
  },
  created() {
    this.throttleCaseHome = throttle(this.bindToCaseHome, 3000)
  },
  methods: {
    //营养头图
    bindToTonicHome() {
      this.$betterwe.jumpRoute('/home?pageTag=1&pageChildType=4&isLogin=1')
    },
    //进线落地页
    bindToMiniprogram() {
      let path =
        '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Furl%3Dhttps%253A%252F%252Fcdnvue.gymcity.com.cn%252Fbetterwe_1.0%252Fvue%252F17a2ddd6ba469d337049c738c3401b83.png'
      this.$betterwe.jumpRoute(path)
    },
    //跳转会员购买页面
    async bindToVip() {
      this.$toast.loading()
      let res = await this.$http
        .postBaseApp('api/v3/WeplusData/getUserWeplusIdentify', {})
        .catch(() => {})
      this.$toast.clear()
      if (res) {
        res = res.data
        if (res.code == 200) {
          let isOldVip = res.data.is_old_weplus
          if (isOldVip) {
            let url = HTTP.getBaseUrl() + '/betterwe/vip'
            this.$betterwe.jumpRoute(
              '/web?url=' + encodeURIComponent(url) + '&isLogin=1'
            )
          } else {
            this.$betterwe.vipHomePage({ isLogin: 1 })
          }
        } else {
          this.$toast(res.msg)
        }
      }
    },
    //跳转营养师导购
    bindToRecommendGoods() {
      this.$betterwe.jumpRoute('/tonicHome?isLogin=1')
    },
    //跳转新人问卷
    bindToNewQuestion() {
      let url = HTTP.getBaseUrl() + '/newcomer-questionnaire-v2/loading'
      this.$betterwe.jumpRoute(
        '/web?url=' + encodeURIComponent(url) + '&isLogin=1'
      )
    },
    bindToTools(index) {
      let functionData = [
        'bindToFollowEat',
        'bindToClock',
        'bindToEatWaht',
        'bindToCalorieQuery',
        'bindToMenu',
        'bindToIngredientsList'
      ]
      this[functionData[index]] && this[functionData[index]]()
    },
    //跳转跟吃
    bindToFollowEat() {
      this.$betterwe.jumpRoute('/followEatCaseGallery?isLogin=1')
    },
    //跳转营养闹钟
    bindToClock() {
      let url = HTTP.getBaseUrl() + '/nutrition-clock/index'
      this.$betterwe.jumpRoute(
        '/web?url=' + encodeURIComponent(url) + '&isLogin=1'
      )
    },
    //跳转今天吃什么
    bindToEatWaht() {
      let url = HTTP.getBaseUrl() + '/eating-today/index'
      this.$betterwe.jumpRoute(
        '/web?url=' + encodeURIComponent(url) + '&isLogin=1'
      )
    },
    //跳转热量查询
    bindToCalorieQuery() {
      let url = HTTP.getBaseUrl() + '/calorie-query/index'
      this.$betterwe.jumpRoute(
        '/web?url=' + encodeURIComponent(url) + '&isLogin=1'
      )
    },
    //跳转减脂菜谱
    bindToMenu() {
      this.$betterwe.jumpRoute('/recipeHome')
    },
    //跳转配料表
    bindToIngredientsList() {
      let url = HTTP.getBaseUrl() + '/ingredient/index'
      this.$betterwe.jumpRoute(
        '/web?url=' + encodeURIComponent(url) + '&isLogin=1'
      )
    },
    //跳转案例详情
    bindToCaseDetail(id) {
      let url = HTTP.getBaseUrl() + '/case-detail?id=' + id
      this.$betterwe.jumpRoute('/web?url=' + encodeURIComponent(url))
    },
    bindScrollCase(e) {
      let scrollLeft = e.target.scrollLeft
      let clientWidth = e.target.clientWidth
      let scrollWidth = e.target.scrollWidth
      if (scrollLeft >= scrollWidth - clientWidth - 2) {
        this.throttleCaseHome()
      }
    },
    bindToCaseHome() {
      this.$betterwe.jumpRoute('/punchInUserCaseList')
    }
  }
}
</script>
<style lang="scss" scoped>
.brand {
  .image-container {
    position: relative;
  }

  .image-item {
    width: 100%;
  }

  .btn {
    position: absolute;
  }

  .btn-1 {
    width: 195px;
    height: 35px;
    bottom: 35px;
    left: 50%;
    transform: translate(-50%, 0%);
  }

  .btn-2 {
    width: 195px;
    height: 35px;
    bottom: 35px;
    left: 50%;
    transform: translate(-50%, 0%);
  }

  .btn-3 {
    width: 76px;
    height: 20px;
    bottom: 496px;
    right: 37px;
  }

  .btn-4 {
    width: 76px;
    height: 20px;
    bottom: 234px;
    right: 37px;
  }

  .btn-5 {
    width: 76px;
    height: 20px;
    left: 32px;
    top: 358px;
  }

  .btn-list {
    position: absolute;
    left: 50%;
    bottom: 572px;
    transform: translate(-50%, 0%);
    width: 309px;
    height: 290px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    .btn-item {
      margin-top: 110px;
      margin-right: 30px;
      margin-bottom: 17px;
      width: 76px;
      height: 20px;
    }

    .btn-item:nth-child(3n) {
      margin-right: 0;
    }
  }

  .case-scroll {
    width: 100%;
    overflow-x: scroll;
    position: absolute;
    left: 0;
    top: 114px;

    .case-list {
      display: inline-flex;
      flex-wrap: nowrap;
      align-items: flex-start;
      padding: 0px 16px;

      .case-item {
        width: 289px;
        margin-right: 10px;
      }
    }
  }
}
</style>
